/**
 * PCK-213 - bytes in a megabyte. Size limits are stored and shown in MB but compared in bytes,
 * so this conversion appeared across the limit services and the uploaders.
 *
 * apps/pwa has its own copy: the two apps are separate builds with no module in common.
 */
export const BYTES_PER_MB = 1024 * 1024

export default { BYTES_PER_MB }
